// root '../../../';

// dependencies
import { Child } from 'pym.js';
import Zion from './utils/Zion';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils & graphic

// styles
import './styles/graphic.scss';

/* develblock:start */

import * as d3 from 'd3';
import { format } from 'd3-format';
import meta from './data/meta.json';
import { stylePremium } from './utils/helpers';
import { bandAxis, linearAxis } from '../../../factory/axes';

import './styles/graphic.scss';

// const d3 = {
//   json,
//   max,
//   min,
//   select,
//   timeFormat,
//   timeParse,
//   timeFormatDefaultLocale,
// };

// formatD3Time();
d3.timeFormatDefaultLocale({
  periods: ['a.m.', 'p.m.'],
  days: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],
  shortDays: ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'],
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'Junio',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  shortMonths: [
    'Ene.',
    'Feb.',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Ago.',
    'Sept.',
    'Oct.',
    'Nov.',
    'Dic.',
  ],
});

const fmtComma = format(',');
const fmtSI = format('.2s');
const fmtThou = format('~s');
const getHeadline = (cur, prev) => {
  if (cur.amt === 0) return null;
  // sample headline from previous graphic
  // US economy added 223,000 jobs in December, unemployment rate dropped to 3.5%
  const rateDir = cur.rate - prev.rate;
  return [
    'US economy',
    cur.amt > 0 ? 'sumó' : 'lost',
    fmtComma(Math.abs(cur.amt)),
    `job${cur.amt !== 1 ? 's' : ''}`,
    `in ${cur.month}.`,
    'Unemployment rate',
    `${(rateDir < 0) ? 'dropped to' : (rateDir > 0) ? 'rose to' : 'remains at'}`,
    `${cur.rate}%.`,
  ].join(' ');
};


const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  console.clear();
}


let minValue;
let maxValue;


// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ id: pkg.name });

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};


const CNNPolitics = false;
const CNNBusiness = false;

stylePremium(CNNPolitics, CNNBusiness);

let data;

d3.json('https://ix.cnn.io/data/jobs-next/employment_situation_latest_es.json').then((jsondata) => {
  // Parse data from the updated structure
  data = jsondata.jobs_data.map(d => ({
    date: d3.timeParse('%Y-%m-%d')(d.date),
    amt: d.change,
    label: d3.timeFormat('%b')(d3.timeParse('%Y-%m-%d')(d.date)),
  })).sort((a, b) => a.date - b.date);

  // Calculate min and max for chart scale
  minValue = Math.min(0, d3.min(data, d => d.amt));
  maxValue = d3.max(data, d => d.amt) * 1.2;

  // Update headline and dek from JSON keys
  d3.select('h1.headline').text(jsondata.notable);
  d3.select('h2.dek').text(jsondata.employ_desc);

  const publishDate = d3.timeFormat('%b %-d, %Y.')(d3.timeParse('%Y-%m-%d')(jsondata.date));
  d3.select('p#timestamp').html(`Notas: Las cifras de empleo reflejan el cambio mensual en empleos no agrícolas y están ajustadas estacionalmente. Los datos de los dos meses más recientes son preliminares. Información actualizada hasta ${jsondata.month}, con corte al ${jsondata.last_updated_str}. El cierre del gobierno federal impidió la recopilación de datos de la encuesta en octubre de 2025. Los valores de ese mes se basaron en un proceso de ponderación estadística.`);

  draw();
  window.onresize = draw;
});

function draw() {
  const container = d3.select('#graphic');
  container.html('');

  const initialWidth = container.node().clientWidth;
  const initialHeight = 400;
  const isMobile = initialWidth <= 500;

  const margins = {
    top: 20,
    right: 20,
    bottom: 25,
    left: isMobile ? 35 : 50,
  };

  const chartWidth = initialWidth - margins.left - margins.right;
  const chartHeight = initialHeight - margins.top - margins.bottom;

  const padding = 0.15;

  const xAxisConfig = {
    orientation: 'bottom',
    range: [0, chartWidth],
    domain: data.map(d => d.date),
    padding,
  };

  const yAxisConfig = {
    orientation: 'left',
    range: [chartHeight, 0],
    domain: [Math.min(0, minValue), maxValue],
    nice: false,
  };

  const { axis: xAxis, scale: x } = bandAxis(xAxisConfig);
  const { axis: yAxis, scale: y } = linearAxis(yAxisConfig);

  const yTicks = isMobile ? 5 : 5;

  const svg = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', initialHeight);

  const g = svg.append('g')
    .attr('transform', `translate(${margins.left},${margins.top})`);

  // X-axis
  g.append('g')
    .attr('class', 'x grid')
    .attr('transform', `translate(0,${chartHeight})`)
    .call(
      xAxis(x).tickFormat(d3.timeFormat('%b')),
    );

  // Y-axis
  g.append('g')
    .attr('class', 'y grid')
    .call(
      yAxis(y)
        .ticks(yTicks)
        .tickSize(-chartWidth)
        .tickFormat(d => (isMobile ? fmtThou(d) : fmtComma(d))),
    );

  // Bars
  const bars = g.append('g').attr('class', 'data');

  bars.selectAll('.bar')
    .data(data)
    .enter().append('rect')
    .attr('class', (d, i) => `bar ${i === data.length - 1 ? 'highlight' : ''} ${d.amt < 0 ? 'loss' : ''}`)
    .attr('x', d => x(d.date))
    .attr('y', d => y(d.amt > 0 ? d.amt : 0))
    .attr('width', x.bandwidth())
    .attr('height', d => Math.abs(y(d.amt) - y(0)));

  // Highlight the last bar with a rounded label
  const lastData = data[data.length - 1];

  if (lastData) {
    g.append('text')
      .attr('class', 'label')
      .attr('x', x(lastData.date) + x.bandwidth() / 2)
      .attr('y', y(lastData.amt > 0 ? lastData.amt : 0) - 10)
      .attr('text-anchor', 'middle')
      .text(fmtThou(lastData.amt).replace('k', 'K'));
  }

  // Zero line if necessary
  if (y.domain()[0] < 0) {
    g.append('line')
      .attr('class', 'zero-bar')
      .attr('x1', 0)
      .attr('x2', chartWidth)
      .attr('y1', y(0))
      .attr('y2', y(0));
  }

  window.pymChild.sendHeight();
  d3.select('#root')
    .attr('class', 'ready');
}
